<template>
  <Modal
    :close-on-outside-click="false"
    :closable="true"
    :show-footer="false"
    :show-header="true"
    :show="isOptionsModalOpen"
    @close="closeOptionsModal"
  >
    <template #header>
      Do you want to join the OU’s membership campaign for just ${{ membershipAmount }}?
    </template>
    <template #body>
      <div class="styled-radio-container styled-radio-container--ou-donation">
        <div class="radio-part">
          <input
            id="monthsly"
            type="radio"
            class="frequency"
            @click="

            setValue('amount', '' + (Number(selectedAmount) + Number(membershipAmount))),

            setValue('custom.membershipType', 'Yes'),
                closeOptionsModal()
            "
          />
          <FormLabel for="monthsly">Yes!</FormLabel>
        </div>
        <div class="radio-part">
          <input
            id="onesTime"
            type="radio"
            class="frequency"
            @click="
            setValue('amount', '' + (Number(selectedAmount))),

            setValue('custom.membershipType', 'No'),
            closeOptionsModal()"
          />
          <FormLabel for="onesTime"
            >No thanks</FormLabel
          >
        </div>
      </div>
    </template>
  </Modal>
</template>
<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    showMsg: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, { emit }) {
    const { setValue, form, getValue } = usePaymentForm();

    const membershipAmount = 108;

    const modalOpen = ref(true);

    const selectedAmount = ref(form.value.amount || 0);
    const isOptionsModalOpen = ref(true);
    const openOptionsModal = () => {
      isOptionsModalOpen.value = true;
    };
    const closeOptionsModal = () => {
      isOptionsModalOpen.value = false;
      emit("close");
    };

    // Set the callback URL for membership subscription
    setValue(
      "callback",
      process.env.NODE_ENV != "production"
        ? "https://www.ou.org/wp-json/api/membership/newsletter"
        : "https://www.ou.org/wp-json/api/membership/newsletter"
    );

    // Watch for changes in custom fields and set signup flag
    watch(
      () => form.value.custom,
      (n, o) => {
        if (JSON.stringify(n) == JSON.stringify(o)) return;
        setValue("signup", Object.values(form.value.custom || {}).length > 0);
      }
    );

    return {
      form,
      selectedAmount,
      monthly: computed(() => !!form.value.dayOfMonth),
      getValue,
      setValue,
      membershipAmount,
      modalOpen,
      isOptionsModalOpen,
      openOptionsModal,
      closeOptionsModal,
    };
  },
});
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0px 0 15px 0px;
  width: 100%;
  display: flex;
  padding-top: 4px;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      flex: 1;
        padding-right: 10px;
        padding-left: 0;
        margin-bottom: 10px;
        min-width: 48% !important;
        max-width: 48% !important;
    }
    &:first-child {
      label {
        background: #e5e8e9;
        color: #222;
      }
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  input[type="radio"]:checked + label {
    background: #1aa8d3;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
}

.monthly__modal {
  background: #f2f5f8;
  padding: 25px 20px;
  border-radius: 4px;
  line-height: 1.4;
  font-size: 15px;
}
.monthly__modal__desc {
  p {
    margin-bottom: 14px;
  }
}
::v-deep .modal-header {
  line-height: 1.4;
  font-weight: 600;
}

// .monthly__wrapper {
//   position: fixed;
//   right: 0px;
//   left: 0px;
//   bottom: 40px;
//   width: 100%;
//   background: white;
//   padding: 0px;
//   box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
//   height: fit-content;
//   max-width: 525px;
//   margin: 25px auto;
//   z-index: 10003;
//   top: 40px;
//   border-radius: 3px;
// }

// .monthly__wrapper {
//   position: fixed;
//   right: 0px;
//   left: 0px;
//   bottom: 40px;
//   width: 100%;
//   background: white;
//   padding: 0px;
//   box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
//   height: fit-content;
//   max-width: 525px;
//   margin: 25px auto;
//   z-index: 10003;
//   top: 40px;
//   border-radius: 3px;
// }
// .monthly__body {
//   background: rgba(128, 128, 128, 0.6);
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   right: 0px;
//   bottom: 0px;
//   top: 0px;
//   width: 100%;
//   height: 100%;
//   z-index: 9999999;
//   display: none;
//   &.monthly__open {
//     display: block;
//   }
// }

::v-deep .modal {
  max-width: 525px;
  line-height: 1.4;
}
</style>
